import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import _, { isArray, keyBy } from 'lodash';
import { clone } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-rail-fare-terms',
  templateUrl: './rail-fare-terms.component.html',
  styleUrls: ['./rail-fare-terms.component.scss'],
  standalone: false
})
export class RailFareTermsComponent implements OnInit {
  public ticketDetails: any = {};
  public includedExtras: string[] = [];
  // Mandatory for Trainline
  ticketConditionsOrdered: any = {
    ticketTypeName: 0,
    description: 1,
    generalValidity: 2,
    preBookingRequirement: 3,
    refundCancellationRule: 4,
    changeRule: 5,
    generalDiscount: 6,
    journeyBreakRule: 7,
    'ADDITIONAL RESTRICTIONS': 8,
    ticketTypeCode: 9,
    ACCESSIBILITY: 10,
    route: 11
  };
  buttonToFocusBack = null;

  ticketIsObject = true;

  constructor(
    public activeModal: NgbActiveModal,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    if (this.document.activeElement?.classList.contains('view_conditions')) {
      const viewConditionsLink = this.document.activeElement;
      const focusable = this.document.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      focusable.forEach((focusableItem, index) => {
        if (focusableItem === viewConditionsLink) {
          this.buttonToFocusBack = focusable[index - 1];
        }
      });
    }
    if (this.ticketDetails) {
      if (isArray(this.ticketDetails)) {
        this.ticketIsObject = false;

        const ticketDetailsClone = clone(this.ticketDetails);
        let newTicketDetails = [];

        for (let ticket of ticketDetailsClone) {
          const arrayTicket = [];
          if (ticket.name && ticket.value) {
            arrayTicket.push([{ key: ticket.name, value: ticket.value }]);
          } else if (ticket.value) {
            const keys = Object.keys(ticket);

            for (const key of keys) {
              if (
                ticket[key] === null ||
                (isArray(ticket[key]) && !ticket[key].length) ||
                key === '__typename'
              ) {
                delete ticket[key];
              } else {
                const newItem = {
                  key,
                  value: ticket[key]
                };
                arrayTicket.push(newItem);
              }
            }
          }

          ticket = arrayTicket;

          // - now sort the keys into order
          ticket = ticket.sort((a, b) => {
            if (a.key === 'ticketTypeName') {
              return -1;
            } else if (a.key > b.key) {
              return -1;
            } else if (b.key > a.key) {
              return 1;
            }
            return 0;
          });

          newTicketDetails = newTicketDetails.concat(...ticket);
        }

        this.ticketDetails = newTicketDetails;
      } else {
        delete this.ticketDetails.__typename;
        delete this.ticketDetails.ticketTypeAltName;

        this.ticketDetails = _.forOwn(this.ticketDetails, (value, key) => {
          if (_.isArray(value)) {
            value.forEach((x) => {
              if (_.has(x, 'name') && _.has(x, 'description')) {
                this.ticketDetails[x.name] = x.description;
              }
            });
            delete this.ticketDetails[key];
          }
        });

        this.ticketDetails['description'] = this.ticketDetails['ticketTypeConditionsDescription'];
        delete this.ticketDetails['ticketTypeConditionsDescription'];

        // Re-order ticket details
        _.forOwn(this.ticketDetails, (value, key) => {
          this.ticketConditionsOrdered[key] = value ?? 0;
        });
        // // Remove the properties do not exist in ticketDetails
        _.forOwn(this.ticketConditionsOrdered, (value, key) => {
          if (typeof value === 'number') {
            delete this.ticketConditionsOrdered[key];
          }
        });
        this.ticketConditionsOrdered = Object.entries(this.ticketConditionsOrdered).map(
          ([key, value]) => ({
            key,
            value
          })
        );
      }
    }
  }

  close() {
    this.activeModal.close(false);
    if (this.buttonToFocusBack) {
      this.buttonToFocusBack.focus();
    }
  }
}

LightningModalTypes.RailFareTermsComponent.component = RailFareTermsComponent;
